import graph from "./graph";
import client from "apollo";
import { isEmptyObject } from "helpers/formatObject";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  isNew: false,
  isAuthenticated: false,
  userToken: null,
  userRoles: [],
  activeRole: {},
  userInfo: {
    wallet: {
      balance: "0",
    },
  },
  loading: false,
  error: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    signIn: (state, action) => {
      const { payload } = action;
      return {
        ...payload,
        isAuthenticated: true,
      };
    },
    signUp: (state, action) => {
      const { payload } = action;
      return {
        ...payload,
        isNew: true,
        isAuthenticated: true,
      };
    },
    updateUser: (state) => {
      const { userInfo } = state;
      return {
        ...state,
        userInfo: {
          ...userInfo,
          firstname: userInfo.firstname,
          lastname: userInfo.lastname,
          email: userInfo.email,
        },
      };
    },
    setRole: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        activeRole: payload,
      };
    },
    signOut: (state, action) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        const {
          payload: {
            id,
            token,
            roles,
            media,
            wallet,
            lastname,
            firstname,
            cellphone,
            all_roles,
            is_active,
          },
        } = action;
        let userRoles = [];
        roles.map((r) => {
          const { id, name, title } = JSON.parse(r);
          return userRoles.push({ id, name, title });
        });
        state.loading = false;
        state.userToken = token;
        state.userRoles = all_roles;
        state.activeRole = all_roles[0];
        state.userInfo = {
          id,
          media,
          token,
          wallet,
          lastname,
          firstname,
          cellphone,
          roles: userRoles,
          isActive: is_active,
        }; // فرض می‌کنیم داده‌های کاربر را در اینجا دریافت می‌کنیم
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // مدیریت خطا
      });
  },
});

export const { signIn, signUp, signOut, setRole } = authSlice.actions;

export default authSlice.reducer;

export const fetchUser = createAsyncThunk("auth/fetchUser", async (token) => {
  try {
    const { data, errors } = await client.query({
      query: graph.user.query,
      context: {
        serviceName: graph.user.serviceName,
        headers: {
          authorization: `Bearer ${token}`,
        },
      },
    });
    if (!errors && !isEmptyObject(data)) {
      return data[graph.user.name];
    }
  } catch (error) {
    return error.message;
  }
  // try {
  //   const response = await fetch("/api/auth/login", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({ username, password }),
  //   });

  //   if (!response.ok) {
  //     throw new Error("Login failed");
  //   }

  //   const data = await response.json();
  //   return data; // بازگشت داده‌های کاربر (مانند توکن و اطلاعات دیگر)
  // } catch (error) {
  //   return rejectWithValue(error.message); // مدیریت خطا
  // }
});
